import { getAuthData } from '../../utils/authUtils';
import AuthorizeContainer from './AuthorizeContainer';
import SelectAccountContainer from './SelectAccountContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectAppContainer = () => {
  const {
    portal
  } = getAuthData();
  if (portal) {
    return /*#__PURE__*/_jsx(AuthorizeContainer, {});
  } else {
    return /*#__PURE__*/_jsx(SelectAccountContainer, {});
  }
};
export default ConnectAppContainer;